import palette from '../../theme/palette';

// we don't actually use this as a 'color'
export const ERASER_COLOR = palette.slate.regular;
export const STROKE_WIDTH = 2;
export const ERASER_WIDTH = 8;
export const COLORS = [
  ERASER_COLOR,
  palette.ink.regular,
  palette.mandarin.bold,
  palette.cherry.bold,
  palette.oregano.bold,
  palette.lavender.bold,
];
